// blog.js
import React, {useEffect} from 'react'
import Navbar from '../components/Navbar';
import {useNavigate} from "react-router-dom";
import { Globals } from '../globalfunctions.js';
function Blog() {
  const navigate = useNavigate();
  useEffect(() => {
    if(Globals.LoginTime===null){
      navigate('/login');
    }
  }, []);
  return (
    <div>
        <Navbar />
      <h1>
        And I'm gonna change tooo!
      </h1>
    </div>
  )
}

export default Blog
